/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Preview_SentenceInputs */



/**
* | output |
* | --- |
* | "The quick brown fox jumps over the lazy dog" |
*
* @param {Options_Fonts_Preview_SentenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_preview_sentence = /** @type {((inputs?: Options_Fonts_Preview_SentenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Preview_SentenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Portez ce vieux whisky au juge blond qui fume")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der schnelle braune Fuchs springt über den faulen Hund")
	if (locale === "it") return /** @type {LocalizedString} */ ("La volpe marrone salta veloce sopra il cane pigro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Быстрая бурая лиса перепрыгивает через ленивую собаку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El rápido zorro marrón salta sobre el perro perezoso.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("敏捷的棕色狐狸跳过了懒惰的狗")
	if (locale === "ja") return /** @type {LocalizedString} */ ("素早い茶色のキツネが怠け者の犬を飛び越える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तेज, भूरी लोमडी आलसी कुत्ते के उपर कूद गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A raposa marrom veloz salta sobre o cachorro preguiçoso.")
	return /** @type {LocalizedString} */ ("The quick brown fox jumps over the lazy dog")
});